import React, { useState, useEffect } from 'react';
import BackgroundGrid from './BackgroundGrid';
import '../styles/HomePage.css';
import SignUpModal from './SignUpModal';
import LogInModal from './LoginModal';
import Header from './Header';
import PicksModal from './PicksModal';
import UserStats from './UserStats';
import Leaderboard from './Leaderboard';
import BowlBashLogo from '../assets/nicks/nbb-logo-3.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import LeaguesPage from './LeaguesPage';
import HallOfFame from './HallOfFame';
import FootballPlayAnimation from './FootballPlayAnimation';
import SvgFilters from "./SvgFilters";
import { motion } from "framer-motion";
import { set } from 'mongoose';


// import ElectricButton from "./ElectricButton";


const HomePage = () => {
  const logoContext = require.context('../assets/logos', false, /\.(png|jpe?g|svg)$/);
  const logos = logoContext.keys().map(logoContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogInModalOpen, setIsLogInModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [picksSubmitted, setPicksSubmitted] = useState(false);
  const [currentSeason, setCurrentSeason] = useState(null); // optional if you want to display or pass it
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const [isPicksModalOpen, setPicksModalOpen] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [userStats, setUserStats] = useState(null);
  const [myStats, setMyStats] = useState(null);
  const [username, setUsername] = useState('');
  const [activeComponent, setActiveComponent] = useState('userStats');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
  const [coffeeX, setCoffeeX] = useState(0);
  const draggableComponents = ["leaderboard", "leagues", "hallOfFame"];
  // const handleComingSoonClick = () => {alert("Thanks for signing up! Picks will open up Sunday night. Stay tuned!");};


  const API_BASE_URL = process.env.REACT_APP_API_URL || '';

  const handlePicksModalClick = () => setPicksModalOpen(true);
  const handleClosePicksModal = () => setPicksModalOpen(false);
  const handleLogin = () => setIsLogInModalOpen(true);

  const handleLogInSuccess = async (userId, username, picksSubmittedFromServer) => {
  setIsLogInModalOpen(false);
  setIsLoggedIn(true);
  setIsHeaderVisible(true);
  setCurrentUserId(userId);
  setUsername(username);
  setPicksSubmitted(picksSubmittedFromServer); // ✅ set this first
  
  console.log('✅ Login successful:', {
      userId,
      username,
      picksSubmittedFromServer
    });

  setActiveComponent('userStats');             // then show user stats
  toast.success('Log In successful!');
};

useEffect(() => {
  const fetchCurrentSeason = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/seasons/current`);
      setCurrentSeason(response.data.season); // e.g., "2025"
    } catch (error) {
      console.error("Error fetching current season:", error);
    }
  };
  fetchCurrentSeason();
}, [API_BASE_URL]);


  // Fetch user stats
  useEffect(() => {
    if (!currentUserId) return;
    const fetchUserStats = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/picks/user/${currentUserId}/picks-and-stats`);
        // setPicksSubmitted(true);
        setUserStats(response.data);
        setUsername(response.data.username);
      } catch (error) {
        console.error('Error fetching user stats:', error);
      }
    };
    fetchUserStats();
  }, [currentUserId, API_BASE_URL]);

  // Fetch my stats
  useEffect(() => {
    if (!currentUserId) return;
    const fetchMyStats = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/mystats/${currentUserId}`);
        setMyStats(response.data);
      } catch (error) {
        console.error('Error fetching my stats:', error);
      }
    };
    fetchMyStats();
  }, [currentUserId, API_BASE_URL]);

    // Animate Buy Me a Coffee button when switching components

    useEffect(() => {
      const mostlyHiddenX = 140;
      const fullyVisibleX = 0;

      // Only adjust when entering a draggable component
      if (isMobile && draggableComponents.includes(activeComponent)) {
        // If coffeeX is currently fully visible, move it to mostly hidden
        if (coffeeX === fullyVisibleX) {
          setCoffeeX(mostlyHiddenX);
        }
        // Otherwise, leave it where it is (so it doesn’t jump)
      } else {
        // When leaving all draggable components, reset to fully visible
        setCoffeeX(fullyVisibleX);
      }
    }, [activeComponent, isMobile]);



  const handleSaveAndClose = async () => {
    setPicksSubmitted(true);
    setPicksModalOpen(false);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/picks/user/${currentUserId}/picks-and-stats`);
      setUserStats(response.data);
    } catch (error) {
      console.error('Error fetching user stats:', error);
    }
  };

const renderActiveComponent = () => {
  if (!isLoggedIn) {
    return (
      <>
        <BackgroundGrid logos={logos} />
        <div className="logo-button-container">
          <div className="logo-container">
            <img src={BowlBashLogo} alt="Nick's Bowl Bash Logo" className="homepage-logo" />
          </div>
          <div className="button-container">
            <SvgFilters />

            {/* Button wrapper for Log In / Sign Up */}
            <div className="button-wrapper">
              <button className="home-page-button" onClick={handleLogin}>Log In</button>
            </div>
            <div className="button-wrapper">
              <button className="home-page-button" onClick={() => setIsModalOpen(true)}>Sign Up</button>
            </div>
          </div>
        </div>
      </>
    );
  }

  switch (activeComponent) {
    case 'userStats': {
    // ✅ If the user hasn't submitted picks, show the Make Picks button immediately
    if (!picksSubmitted) {
      return (
        <>
        <div className='make-picks-wrapper'>
          {/* Make Picks button */}
          <div className="button-wrapper">
            <button
              onClick={handlePicksModalClick}
              // onClick={handleComingSoonClick}
              className="home-page-button-mp"
            >
              Make Picks
            </button>
          </div>
          </div>
          
          {/* Background animation */}
          <FootballPlayAnimation className="football-play-animation-background football-play" />

          {/* Filters or effects */}
          <SvgFilters />

          
        </>
      );
    }


    // 🟡 Show loading while fetching userStats (only for users who HAVE submitted picks)
    if (!userStats) {
      return <div className="loading">Loading your stats...</div>;
    }

    // ✅ Otherwise show UserStats
    return <UserStats stats={userStats} mystats={myStats} />;
  }

    case 'leaderboard':
      return <Leaderboard />;

    case 'leagues':
      return <LeaguesPage />;

    case 'hallOfFame':
      return <HallOfFame />;

    default:
      return null;
  }
};

console.log('🎯 Render:', { picksSubmitted, userStats });


  return (
    <div className="HomePage">
      {isHeaderVisible && (
        <Header
          onSwitch={(component) => setActiveComponent(component)}
          username={username}
        />
      )}

      {isModalOpen && <SignUpModal closeModal={() => setIsModalOpen(false)} />}

      {isLogInModalOpen && (
        <LogInModal
          isOpen={isLogInModalOpen}
          onClose={() => setIsLogInModalOpen(false)}
          onLogInSuccess={handleLogInSuccess}
          switchToSignUp={() => {
            setIsLogInModalOpen(false);
            setIsModalOpen(true);
          }}
          setUserPicksSubmitted={setPicksSubmitted}
        />
      )}

      {isPicksModalOpen && (
        <div className="modal-overlay">
          <PicksModal
            onClose={handleClosePicksModal}
            currentUserId={currentUserId}
            onSaveAndClose={handleSaveAndClose}
          />
        </div>
      )}

      <main>{renderActiveComponent()}</main>

      {/* Buy Me a Coffee button */}
      <motion.a
        href="https://www.buymeacoffee.com/nicksbowlbash"
        target="_blank"
        rel="noopener noreferrer"
        className="buy-me-coffee-button"
        initial={false} // prevents jump on mount
        animate={{
          x: isPicksModalOpen
            ? "100vw" // hide completely when picks modal open
            : isMobile && ["leaderboard", "leagues", "hallOfFame"].includes(activeComponent)
            ? coffeeX
            : 0,
          opacity: 1
        }}
        transition={{ type: "spring", stiffness: 150, damping: 20 }}
        drag={isMobile && ["leaderboard", "leagues", "hallOfFame"].includes(activeComponent) ? "x" : false}
        dragConstraints={{ left: 0, right: 140 }} // fully visible to mostly hidden
        dragElastic={0.3}
        whileHover={{ scale: 1.05 }}
        onDragEnd={(event, info) => {
          if (!(isMobile && ["leaderboard", "leagues", "hallOfFame"].includes(activeComponent))) return;

          const mostlyHiddenX = 140;
          const fullyVisibleX = 0;
          const threshold = mostlyHiddenX / 2;

          // Snap logic: dragged left far enough → fully visible; otherwise → mostly hidden
          if (info.offset.x < -threshold) {
            setCoffeeX(fullyVisibleX);
          } else {
            setCoffeeX(mostlyHiddenX);
          }
        }}
      >
        ☕ Buy Nick a Coffee
      </motion.a>



    </div>
  );
};

export default HomePage;
